import React, { useState } from 'react'
import { socialMediaLinks, option1, showAspectRatioData } from 'config/static-data/editor-modal-data'
import Link from 'next/link'
import { copyToClipboard } from 'utils/mediaUtils'
import { useDispatch, useSelector } from 'react-redux'
import useOutsideClick from 'hooks/useOutsideClick'
import { useMediaQuery } from 'react-responsive'
import PromptSelection from './PromptSelection'
import { aiBtnList, defaultSelectedModel } from 'utils/constants'

const EditorModalHeader = ({
  selectedParameters,
  setSelectedParameters,
  handleSelectedOptionChange,
  setAspectRatio,
  aspectRatio,
  setImagesToGenerate,
  imagesToGenerate,
  handleImageGeneration,
  setImagePrompt,
  imagePrompt,
  constructModalUrl,
}) => {
  const [expandSearchInput, setExpandSearchInput] = useState(false)
  const [shareDropdown, setShareDropdown] = useState(false)
  const dispatch = useDispatch()
  const [showAspectRatio, setShowAspectRatio] = useState(false)
  const [selectedAiModel, setSelectedAiModel] = useState(defaultSelectedModel)
  const [showAiModels, setShowAiModels] = useState(false)
  const { textToImagePrompts } = useSelector((state) => state.prompt)

  const dropdownRef = useOutsideClick(() => {
    setShareDropdown(false)
    setShowAiModels(false)
  })
  const isMobile = useMediaQuery({ maxWidth: 600 })

  const handleEnterKey = (e) => {
    e.keyCode === 13 && handleImageGeneration(selectedAiModel)
  }

  const handleSelectedParaRemove = (key) => {
    selectedParameters?.[key] &&
      setSelectedParameters((prev) => {
        const newParameters = { ...prev }
        delete newParameters[key]
        return newParameters
      })
  }
  return (
    <div className="generate-box-header flex flex-col  justify-center items-center w-full z-10 relative bg-white">
      <div className=" flex flex-col w-full">
        <div
          className={`min-w-[70%] bg-white px-2 py-1  border border-solid border-[#A5A5A5] rounded `}
          ref={dropdownRef}
        >
          <div className=" flex ">
            <div
              className="relative flex justify-center items-center mr-2 z-10"
              onClick={() => setShowAiModels(!showAiModels)}
            >
              <button className="flex items-center gap-2 text-white text-base font-black  py-1 px-3 leading-10 bg-black">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="#909090"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {showAiModels && (
                <div className="absolute z-[999] left-0 min-w-full w-max top-[33px]">
                  <div className=" relative bg-black rounded-sm py-2 flex flex-col  border-none">
                    {Object.keys(aiBtnList)
                      .filter((key) => !aiBtnList[key].ai)
                      .map((key, i) => {
                        return (
                          <p
                            key={i}
                            className="bg-transparent text-xs  text-center font-medium px-3 py-2 text-[#fff] cursor-pointer capitalize hover:bg-slate-950"
                            onClick={() => setSelectedAiModel(key)}
                          >
                            {aiBtnList[key].label}
                          </p>
                        )
                      })}
                  </div>
                </div>
              )}
            </div>
            <input
              type="text"
              placeholder="Enter prompt to Generate Image"
              className="w-full"
              value={imagePrompt}
              onFocus={() => setExpandSearchInput(true)}
              onChange={(e) => setImagePrompt(e.target.value)}
              onKeyDown={handleEnterKey}
            />
            <div className="w-[30%] flex gap-2 justify-end">
              <button
                className={`border border-solid border-neutral-300 rounded flex justify-center items-center h-[30px] w-[30px]   ${expandSearchInput && '!bg-black text-white'}`}
                onClick={() => setExpandSearchInput(!expandSearchInput)}
                disabled={!textToImagePrompts}
              >
                <img
                  src={'/assets/common/setting-editor.svg'}
                  alt="setting"
                  className={`w-5 h-5 ${expandSearchInput && 'invert'}`}
                />
              </button>
              <div
                className={`relative border border-solid border-neutral-300 rounded flex justify-center items-center h-[30px] w-[30px]  ${shareDropdown && '!bg-black'}`}
                onClick={() => setShareDropdown(!shareDropdown)}
              >
                <img
                  src={'/assets/common/share-news.svg'}
                  alt="share"
                  className={`w-5 h-5 ${shareDropdown && 'invert'}`}
                />

                {shareDropdown && (
                  <div className="absolute top-[50px] right-0 py-4 px-6 w-[300px]  z-10 bg-white rounded-lg shadow-xl">
                    <div className="flex flex-col ">
                      <h3 className="mb-4 text-lg font-medium text-deepblue-900 dark:text-neutral-100">Send link</h3>
                      <p className="mb-4 text-left text-sm font-normal text-neutral-800 dark:text-neutral-300">
                        Share your prompt with the world
                      </p>
                      <div className="flex items-center justify-center gap-2">
                        <div
                          className="relative flex h-10 w-full min-w-0 items-center truncate rounded border border-neutral-100/75 px-3 text-sm text-deepblue-900 hover:text-deepblue-700 dark:border-neutral-300 dark:text-neutral-300 dark:hover:text-neutral-100"
                          onClick={() => dispatch(copyToClipboard(constructModalUrl()))}
                        >
                          <span className="w-full truncate">{constructModalUrl()}</span>
                          <img src={`/assets/common/copy.svg`} className={`w-5 h-5 `} alt="copy" />
                        </div>

                        <div className="flex items-center justify-center gap-2 ">
                          {socialMediaLinks.map((item) => {
                            return (
                              <div key={item?.id} className={`w-6 h-6 flex justify-center  hover:opacity-60`}>
                                <Link href={item?.link} target={item.target} className="text-white hover:text-gray-500">
                                  <img src={`/assets/footer/${item?.icon}.svg`} alt={item?.icon} />
                                </Link>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {expandSearchInput && (
            <>
              {Object.keys(selectedParameters)?.length > 0 && (
                <div className="flex flex-wrap gap-4 mt-2 py-2 ">
                  {Object.keys(selectedParameters)?.map((item, i) => {
                    return (
                      selectedParameters[item] && (
                        <div className="flex items-center gap-2 pr-1 rounded-full overflow-hidden bg-white text-gray-900 border border-gray-300 border-solid">
                          <img
                            src={i < 10 ? `/assets/editor-modal/image${i + 1}.png` : `/assets/editor-modal/image1.png`}
                            className="h-6 w-6"
                            alt="editor"
                          />
                          <span className="font-bold text-xs whitespace-nowrap overflow-hidden text-ellipsis">
                            {selectedParameters[item]?.title}
                          </span>
                          <span
                            className="rounded-full bg-gray-300 p-1 w-5 h-5"
                            onClick={() => handleSelectedParaRemove(item)}
                          >
                            <img src="/assets/common/close.svg" alt="close" />
                          </span>
                        </div>
                      )
                    )
                  })}
                </div>
              )}

              <div className="flex justify-ceter items-center mt-2 gap-4 transition-height duration-150 ease-in">
                <div className="relative">
                  <button
                    className="group/ratio flex h-8 items-center justify-center gap-2 rounded text-neutral-900 "
                    onClick={() => setShowAspectRatio(!showAspectRatio)}
                  >
                    <label className="text-xs font-semibold text-deepblue-900">Ratio </label>
                    <div className="flex h-8 items-center justify-center gap-2 rounded px-2 border border-solid border-neutral-200">
                      <div className="flex items-center">
                        <span className="ml-1 text-xs font-bold ">{aspectRatio}</span>
                      </div>

                      <div className="flex  items-center justify-center ">
                        <img src={'/assets/common/arrow_down.svg'} alt="arrow" />
                      </div>
                    </div>
                  </button>

                  {showAspectRatio && (
                    <div className="z-[90] absolute top-[30px] left-0 shadow-md">
                      <div className="flex flex-col rounded-lg bg-white p-1 shadow-xl dark:bg-gray-700">
                        {showAspectRatioData?.map((item, i) => {
                          return (
                            <span
                              className="flex cursor-pointer items-center gap-1 rounded px-2.5 py-2 text-xs font-semibold text-neutral-900 hover:bg-neutral-50 dark:text-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                              onClick={() => {
                                setAspectRatio(item?.value)
                                setShowAspectRatio(false)
                              }}
                              key={i}
                            >
                              <span className="whitespace-nowrap min-w-[30px]">{item?.value}</span>
                              <span className="whitespace-nowrap">{item?.label}</span>
                            </span>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <label className="text-xs font-semibold text-deepblue-900">Images</label>

                  <div className="flex h-8 items-center justify-center gap-1 rounded border border-solid border-neutral-200 px-2 text-deepblue-900 ">
                    <button
                      className={`${imagesToGenerate == 1 && 'pointer-events-none opacity-40'}`}
                      onClick={() => setImagesToGenerate(imagesToGenerate - 1)}
                    >
                      -
                    </button>

                    <span className="w-4 text-center text-xs font-bold">{imagesToGenerate}</span>

                    <button
                      onClick={() => setImagesToGenerate(imagesToGenerate + 1)}
                      className={`${imagesToGenerate == 4 && 'pointer-events-none opacity-40'}`}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <button
          className={`w-full mt-2 text-white text-sm font-medium   rounded  py-2 px-6  bg-black`}
          onClick={() => handleImageGeneration(selectedAiModel)}
        >
          Generate
        </button>
        <div className="flex justify-center items-center w-full overflow-y-auto">
          <div className="w-[90%]">
            {expandSearchInput && (
              <PromptSelection
                option1={option1}
                isMobile={isMobile}
                handleSelectedOptionChange={handleSelectedOptionChange}
                selectedParameters={selectedParameters}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditorModalHeader
